<div class="obs">
    <div class="obs-empty" *ngIf="!hasAccount()">
        <i class="fa fa-hand-o-up"></i>
        <span>Pick an account above to watch its screen.</span>
    </div>

    <div class="logs-alert obs-alert" *ngIf="error">
        <i class="fa fa-exclamation-triangle"></i>
        <span>{{ error }}</span>
    </div>

    <div class="obs-empty" *ngIf="hasAccount() && !hasFrames() && !error">
        <i class="fa fa-hourglass-half"></i>
        <span>No frames yet for this account.</span>
    </div>

    <div class="obs-stage" *ngIf="hasFrames()">
        <img *ngIf="displayedUrl()" [src]="displayedUrl()" [alt]="'frame ' + current().seq"/>

        <div class="obs-loading" *ngIf="!displayedUrl()">
            <i class="fa fa-spinner fa-spin"></i>
            <span>Loading frame…</span>
        </div>

        <div class="obs-catching-up" *ngIf="displayedUrl() && isStale()">
            <i class="fa fa-spinner fa-spin"></i>
        </div>
    </div>

    <div class="obs-controls" *ngIf="hasFrames()">
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="step(-1)" title="Previous frame">
            <i class="fa fa-step-backward"></i>
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="togglePlayback()"
                [title]="playing ? 'Pause playback' : 'Play forward'">
            <i class="fa" [class.fa-play]="!playing" [class.fa-pause]="playing"></i>
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="step(1)" title="Next frame">
            <i class="fa fa-step-forward"></i>
        </button>

        <input type="range" class="form-range obs-slider" min="0" [max]="frames.length - 1"
               [(ngModel)]="index" (ngModelChange)="onSliderChange()"/>

        <span class="obs-stat col-mono">{{ index + 1 }} / {{ frames.length }}</span>
        <span class="obs-stat col-mono">{{ clock(current()) }}</span>
        <span class="obs-stat col-mono">+{{ elapsed(current()) }}</span>

        <button type="button" class="btn btn-sm" [class.btn-primary]="live" [class.btn-outline-secondary]="!live"
                (click)="goLive()" title="Jump to the newest frame and keep following">
            <i class="fa fa-bolt"></i>
            <span>Live</span>
            <span class="obs-behind" *ngIf="live && behind() > 0">+{{ behind() }}</span>
        </button>
    </div>
</div>
